/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *\

  Color helpers that I've been using since forever

  Example: 
  Ingest a css string, change the saturation and value and return the css-formatted string.
  KitColor.fromCSS('#003333').hsv({s:90, v:50}).css()

  Author Alex Lowe

  Neat tool
  https://www.hslpicker.com/#fb58a4

\* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

//hex to rgb
//rgb: { r:[0-255], g:[0-255], b:[0-255]}
export const hex2rgb = (hx) => {
    if(hx == 0 || !hx) {
   return {r:0, g:0, b:0};
   }
var o = {};
o.r = hx >> 16 & 0xFF;
o.g = hx >> 8 & 0xFF;
o.b = hx & 0xFF;
return o;
}
export const rgb2hex = (o) => {
return ((o.r << 16) + (o.g << 8) + (o.b));
}


export const hex2css= (hx) => {
   if(hx == 0 || !hx) {
   return '#000000';
   }
var t = "#000000";
var s = hx.toString(16);
return t.substring(0,7 - s.length) + s;
}
export const css2hex= (strng) => {
var h = strng.slice(1);
return parseInt(h, 16);
}

//rgb: { r:[0-255], g:[0-255], b:[0-255]}
//css: css hx string like #FF0000
export const rgb2css = (o) => {
return hex2css(rgb2hex(o));
}
export const css2rgb = (strng) => {
return hex2rgb(css2hex(strng));
}

//Thank you,
//https://stackoverflow.com/questions/13806483/increase-or-decrease-color-saturation
//Also,
//https://donatbalipapp.medium.com/colours-maths-90346fb5abda
//https://changingminds.org/explanations/perception/visual/hsl.htm
//
// parameters:
// o: { r:[0-255], g:[0-255], b:[0-255]}
// 
// returns { h, s, v}
// h: [0 - 360]
// s: [0 - 100]
// v: [0 - 100]
export const rbg2hsv = (o) => {
  let h,s,v

  const r = o.r/255 
  const g = o.g/255 
  const b = o.b/255

  const min = Math.min( r, g, b );
  const max = Math.max( r, g, b );

  v = max;
  const delta = max - min;
  if( max != 0 )
      s = delta / max;        // s
  else {
      // r = g = b = 0        // s = 0, v is undefined
      s = 0;
      h = -1;
      return {h, s, v:null};
  }
  if( r === max )
      h = ( g - b ) / delta;      // between yellow & magenta
  else if( g === max )
      h = 2 + ( b - r ) / delta;  // between cyan & yellow
  else
      h = 4 + ( r - g ) / delta;  // between magenta & cyan
  h *= 60;                // degrees
  if( h < 0 )
      h += 360;
  if ( isNaN(h) )
      h = 0;

  return {h,s:s*100,v:v*100};
};

export const hsv2rgb = ({h,s,v}) => {
  let i;
  let r,g,b
  if(s === 0 ) {
      // achromatic (grey)
      r = g = b = v;
      return {r,g,b};
  }
  h /= 60;            // sector 0 to 5
  s /= 100 
  v /= 100
  i = Math.floor( h );
  const f = h - i;          // factorial part of h
  const p = v * ( 1 - s );
  const q = v * ( 1 - s * f );
  const t = v * ( 1 - s * ( 1 - f ) );
  switch( i ) {
      case 0:
          r = v;
          g = t;
          b = p;
          break;
      case 1:
          r = q;
          g = v;
          b = p;
          break;
      case 2:
          r = p;
          g = v;
          b = t;
          break;
      case 3:
          r = p;
          g = q;
          b = v;
          break;
      case 4:
          r = t;
          g = p;
          b = v;
          break;
      default:        // case 5:
          r = v;
          g = p;
          b = q;
          break;
  }
  return {r:Math.round(r*255),g:Math.round(g*255),b:Math.round(b*255)};
}

//https://www.niwa.nu/2013/05/math-behind-colorspace-conversions-rgb-hsl/
// returns { h, s, v}
// h: [0 - 360]
// s: [0 - 1]
// v: [0 - 1]
export const rgb2hsl = (o) => {
  let h,s,l

  const r = o.r/255 
  const g = o.g/255 
  const b = o.b/255

  const min = Math.min( r, g, b );
  const max = Math.max( r, g, b );

  l = (min + max)/2

  const delta = max - min;

  s = 0

  if(delta > 0) {
    if(l <= 0.5) {
      s = (delta)/(max+min)
    } else {
      s = (delta)/(2-delta)
    }
  }

  if( r === max )
    h = ( g - b ) / delta;      // between yellow & magenta
  else if( g === max )
    h = 2 + ( b - r ) / delta;  // between cyan & yellow
  else
    h = 4 + ( r - g ) / delta;  // between magenta & cyan

  h *= 60;                // degrees
  if( h < 0 )
      h += 360;
  if ( isNaN(h) )
      h = 0;

  return {h, s, l};
};




function _hsl2RGBHelper(q, p, t) {
  if (t < 0) t += 1;
  if (t > 1) t -= 1;

  if(6 * t < 1) {
    return p + (q - p)*6*t
  } 
  else 
  if(2*t < 1) {
    return q
  }  
  else 
  if(3*t < 2) {
    return p + (q - p)*(0.666 - t)*6 
  } 
  
  return p;
}



//thank you https://stackoverflow.com/questions/2353211/hsl-to-rgb-color-conversion
//thank you http://niwa.nu/2013/05/math-behind-colorspace-conversions-rgb-hsl/
//
// h: [0-360]
// s: [0-1]
// l: [0-1]
// 
export const hsl2rgb = ({h, s, l}) => {
  let r, g, b;

  //turn to [0-1]
  h /= 360

  //if no saturation, then grey.
  if (s === 0) {
    r = g = b = l; 
  } else {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;

    r = _hsl2RGBHelper(q, p, h + 1/3);
    g = _hsl2RGBHelper(q, p, h);
    b = _hsl2RGBHelper(q, p, h - 1/3);
  }

  return {r: Math.round(r * 255), g: Math.round(g * 255), b: Math.round(b * 255)};
}




/**
 * @param {String} css. required. The CSS color string 
 * @param {Number} pct. required. From [-1 1]. The amount of shift. positive will brighten, negative will darken
 * @returns {String} the brighter or darker CSS string
 * 
 */
export const bright = (css, pct) => {
  if(pct < -1 || pct > 1) {
    return css
  }

  const {r,g,b} = css2rgb(css)
  const dr = pct > 0 ? 255 - r : r  
  const dg = pct > 0 ? 255 - g : g 
  const db = pct > 0 ? 255 - b : b 

  const r2 = Math.round(r+dr*pct)
  const g2 = Math.round(g+dg*pct)
  const b2 = Math.round(b+db*pct)
  
  return rgb2css({r:r2, g:g2, b:b2})
}


//object to this kind of list: 255, 34, 60 
//with an optional alpha channel. Handy for gradients
export const rgb2list = (o, alpha) => {
return alpha || alpha === 0 
    ? `${o.r}, ${o.g}, ${o.b}, ${alpha}`
    : `${o.r}, ${o.g}, ${o.b}`
}
export const list2rgb = (l) => {
const split = l.split(',');
  return {
    r:parseInt(split[0]), 
    g:parseInt(split[1]), 
    b:parseInt(split[2]) 
  }
}

//#0066CC => 255, 34, 50
export const css2list = (c, alpha) => {
  return rgb2list(css2rgb(c), alpha);
}
export const list2css = (l) => {
  return rgb2css(list2rgb(l))
}

//0x0066CC => 255, 34, 50
export const hex2list = (c, alpha) => {
  return rgb2list(hex2rgb(), alpha);
}
export const list2hex = (l) => {
  return rgb2hex(list2rgb(l))
}


//luminosity-based greying
//
// rgb. required. rgb color object.
//
// amount. required. from [0, 1]
//
//
export const greyerRGB = ( {r, g, b}, amount) => {
  // Calculate the luminosity (perceived brightness) of the original color
  const greyValue = Math.round(0.299 * r + 0.587 * g + 0.114 * b);

  // Blend the original color with the grey value
  // 'amount' should be between 0 (no change) and 1 (fully desaturated to grey)
  const newR = Math.round(r + (greyValue - r) * amount);
  const newG = Math.round(g + (greyValue - g) * amount);
  const newB = Math.round(b + (greyValue - b) * amount);

  // Ensure values stay within 0-255 range
  return {
    r: Math.max(0, Math.min(255, newR)),
    g: Math.max(0, Math.min(255, newG)),
    b: Math.max(0, Math.min(255, newB))
  };
}

export const whiterRGB = ({r, g, b}, pct) => {
  if(pct < -1 || pct > 1) {
    return { r, g, b}
  }

  const dr = pct > 0 ? 255 - r : r  
  const dg = pct > 0 ? 255 - g : g 
  const db = pct > 0 ? 255 - b : b 

  const r2 = Math.round(r+dr*pct)
  const g2 = Math.round(g+dg*pct)
  const b2 = Math.round(b+db*pct)
  
  return {r:r2, g:g2, b:b2}
}


class _KitColor {

  r = 0 
  g = 0 
  b = 0
  clean = true
  hxClean = false 
  cssClean = false
  hsvClean = false
  _hx = 0 
  _css = ''
  _hsv = {}
  _hsvBatch = false

  constructor() {
    this.r = 0 
    this.g = 0
    this.b = 0
  }

  static fromRGB({r, b, g}) {
    const inst = new _KitColor()
    inst.r = r 
    inst.g = g 
    inst.b = b
    return inst
  }

  static fromHex(hex) {
    const rgb = hex2rgb(hex) 
    const inst = _KitColor.fromRGB(rgb)
    inst._hx = hex 
    inst.hxClean = true
    return inst
  } 

  static fromCSS(css) {
    const rgb = css2rgb(css); 
    const inst = _KitColor.fromRGB(rgb)
    inst._css = css 
    inst.cssClean = true
    return inst
  }

  static fromHSV(hsv) {
    const rgb = hsv2rgb(hsv)
    const inst = _KitColor.fromRGB(rgb)
    const {h,s,v} = hsv 
    inst._hsv = {h,s,v}
    inst.hsvClean = true 
    return inst
  }

  setR(rVal) {
    this.r = rVal 
    this.hxClean = false
    this.cssClean = false
    this.hsvClean = false
    return this
  }

  setG(gVal) {
    this.g = gVal 
    this.hxClean = false
    this.cssClean = false
    this.hsvClean = false
    return this
  }

  setB(bVal) {
    this.b = bVal 
    this.hxClean = false
    this.cssClean = false
    this.hsvClean = false
    return this
  }

  //set the h
  setHex(hx) {
    const {r,g,b} = hex2rgb(hx) 
    this.r = r 
    this.g = g 
    this.b = b 
    this._hx = hx 
    this.hxClean = true
    this.cssClean = false
    this.hsvClean = false
    return this
  }

  hex() {
    if(this.hxClean) {
      return this._hx
    } else {
      const hx = rgb2hex(this) 
      this._hx = hx 
      this.hxClean = true
      return hx
    } 
  }

  //Set the css string
  setCSS(css) {
    const { r, g, b} = css2rgb(css); 
    this.r = r 
    this.g = g 
    this.b = b 
    this._css = css
    this.hxClean = false
    this.cssClean = true
    this.hsvClean = false
    return this
  }

  //get the css string
  css() {
    if(this.cssClean) {
      return this._css
    } else {
      const css = rgb2css(this) 
      this._css = css 
      this.cssClean = true
      return css
    }    
  }

  //Set an object with any of the properties h,s,v
  //H: [0-360] (degrees)
  //S: [0-100] (percent)
  //V: [0-100] (percent)
  setHSV(o) {

    if(!this.hsvClean) {
      const hsv = rbg2hsv(this); 
      this._hsv = hsv 
      this.hsvClean = true 
    }

    //There's a weird thing where the saturation at 0 makes things
    //dark in this regime so we don't let it get all the way to zero
    if(o.s == 0 && o.v > 70) {
      o.s = 1
    }
    
    const h = o.h === undefined ? this._hsv.h : o.h 
    const s = o.s === undefined ? this._hsv.s : o.s 
    const v = o.v === undefined ? this._hsv.v : o.v 

    const {r,g,b} = hsv2rgb({h,s,v})

    this.r = r 
    this.g = g 
    this.b = b 

    this._hsv = {h,s,v}
    this.hsvClean = true 
    this.hxClean = false
    this.cssClean = false
    return this
  }

  //If you have a lot of calculation to do,
  //you can do it in a batch and it won't update everything.
  //Once you're done you can end the batch and it will run the update
  startHSVBatch() {
    this._hsvBatch = true
    return this
  }
  endHSVBatch() {
    this._hsvBatch = false
    const hsv = this._hsv
    this.setHSV(hsv)
    return this
  }

  //Apply delta, use any of the properties dh, ds, dv.
  //
  //  ratio, boolean. If true, then the dh, ds, dv will be 
  //  ratios on the interval [0, 1] and will represent the ratio of the distance 
  //  to get to the boundaries. So if s=80 and we say ds=0.5 with the ratio flag,
  //  then it will increase s by half the distance between 80 and 100. So, 90.
  // 
  //  If ratio is false/falsy, then the delta is going to be an absolute value to apply
  //
  hsvDelta({dh, ds, dv}, ratio) {
    const {h,s,v} = this.hsv()
    let H,S,V 

    const DH = dh || 0
    const DS = ds || 0 
    const DV = dv || 0

    //If ratio, then treat it as a ratio. Might be positive or negative
    if(ratio) {
      H = DH > 0 ? h + (360 - h)*DH : h*(1+DH)
      S = DS > 0 ? s + (100 - s)*DS : s*(1+DS)
      V = DV > 0 ? v + (100 - v)*DV : v*(1+DV)
    } 
    
    //else, just treat it as an absolute amount
    else {
      H = dh === undefined ? h : h + dh 
      S = ds === undefined ? s : s + ds 
      V = dv === undefined ? v : v + dv
    }

    //wrap this around. So if H is 370,
    //then it's 10.
    if(H > 360) {
      while(H > 360) {
        H -= 360
      } 
    }
    if(H < 0) {
      while(H < 360) {
        H += 360
      } 
    }
    if(S > 100) {
      S = 100
    }
    if(S < 0) {
      S = 0
    }
    if(V > 100) {
      V = 100
    } 
    if(V < 0) {
      V = 0
    }

    this.hsv({h:H, s:S, v:V})

    return this
  }


  dH(dh, ratio) {
    return this.hsvDelta({ dh }, ratio)
  }

  dS(ds, ratio) {
    return this.hsvDelta({ ds }, ratio)
  }

  dV(dv, ratio) {
    return this.hsvDelta({ dv }, ratio)
  }
  H(h) {
    this._hsv.h = h 
    this.hsv(this._hsv)
    return this
  }
  S(s) {
    this._hsv.s = s 
    this.hsv(this._hsv)
    return this
  }
  V(v) {
    this._hsv.v = v 
    this.hsv(this._hsv)
    return this
  }


  //get or set the hsv channels.
  //if used as a setter, then o can have any of the properties h,s,v
  //H: [0-360] (degrees)
  //S: [0-100] (percent)
  //V: [0-100] (percent)
  hsv(o) {
    
    //if setter, then set.
    //If we're in a batch, then just record the object
    //and skip all the arithmetic
    if(o) {
      if(!this._hsvBatch) {
        return this.setHSV(o)
      } else {
        this._hsv = o
        return this
      }
    }

    //else, return the hsv channels
    if(this.hsvClean) {
      return this._hsv
    } else {
      const hsv = rbg2hsv(this); 
      this._hsv = hsv 
      this.hsvClean = true 
      return hsv
    }
  }

  //make this greyer
  greyer(amount) {
    const {r,g,b} = greyerRGB(this, amount)
    this.r = r 
    this.g = g 
    this.b = b 
    this.hxClean = false 
    this.cssClean = false
    this.hsvClean = false
    return this
  }

  //make this whiter
  whiter(amount) {
    const {r,g,b} = whiterRGB(this, amount)
    this.r = r 
    this.g = g 
    this.b = b 
    this.hxClean = false 
    this.cssClean = false
    this.hsvClean = false
    return this
  }

  //TODO this value should be calculated lazily and refreshed
  basicColor() {
    const { h } = this.hsv()

    if(h > 0 && h <= 10) {
      return 'red'
    } else 

    if(h > 10 && h <= 35) {
      return 'orange'
    } else 
      
    if(h > 35 && h <= 70) {
      return 'yellow'
    } 

    else 
    if(h > 70 && h <= 150) {
      return 'green'
    }

    else 
    if(h > 150 && h <= 255) {
      return 'blue'
    }

    else 
    if(h > 255 && h <= 300) {
      return 'purple'
    }

    else 
    if(h > 300 && h <= 330) {
      return 'pink'
    }

    else 
    if(h > 330 && h <= 360) {
      return 'red'
    }

  }


  //This will return a color suitable for a hover state.
  //It's going to saturate.
  //https://en.wikipedia.org/wiki/HSL_and_HSV#/media/File:Hsl-hsv_models.svg
  toHover() {

    //This explains what we're doing. Yellow looks stupid when we darken it.
    //so we're going to see if it's the yellowish range. If so then we're going to
    //bring that hue down a bit. 
    //https://en.wikipedia.org/wiki/HSL_and_HSV#/media/File:Hsl-hsv_models.svg
    if(this.basicColor() == 'yellow') {
      //this.startHSVBatch().S(100).dV(-0.1, true).endHSVBatch()
      this.hsvDelta({ dh: -0.15, ds:0.3, dv:-0.1 }, true)
    } else {
      this.hsvDelta({ dh: 0, ds:0.3, dv:-0.2 }, true)
    }

    return this
  }

  toFlash() {
    let { v } = this.hsv()

    //if it's already bright, then we're going to make it lighter
    //then just crank the value all the way to 100 ande make it way whiter
    if(v > 90) {
      this.startHSVBatch().dS(-0.4, true).V(100).endHSVBatch()
    } 
    
    //Else, increase the value and  bring it closer to white.
    else {
      this.hsvDelta({ ds:-0.2, dv:0.2 }, true)
    }

    return this
  }

  clone() {
    const inst = KitColor.fromRGB(this)
    return inst
  }


}

export const KitColor = _KitColor